import {
  DEFAULT_CURRENCY,
  SLOT_SYMBOL_IMAGES,
} from "../../../../static/Constants";

/**
 * 1 Dropdown with exactly 2 Options: Fiat Slot vs Crypto Slot
 */
export const SLOT_TYPE_OPTIONS = [
  {
    id: "fiat",
    label: "Fiat Slot",
    badge: "Fiat Slot",
    description:
      "Classic casino symbols: Golden Bell (Mini), Diamond (Major), Royal Crown (Mega Jackpot), Casino Cherries (Free Spins), Lucky 7 (Super Spins), Lucky Clover & Golden Coin.",
    defaultCurrency: DEFAULT_CURRENCY || "BET",
  },
  {
    id: "crypto",
    label: "Crypto Slot",
    badge: "Crypto Slot",
    description:
      "Authentic 3D crypto coins: Polygon POL (Mini), Ethereum ETH (Major), Bitcoin BTC (Mega Jackpot), Solana SOL (Free Spins), Tether USDT (Super Spins), Binance BNB & AutoBET Token.",
    defaultCurrency: DEFAULT_CURRENCY || "BET",
  },
];

export const POKIES_TYPE_OPTIONS = SLOT_TYPE_OPTIONS;

/**
 * FIAT Slot 5-Symbol Set (For 3-SlotBET: Contract Mapped 0 to 4)
 */
export const FIAT_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "bell",
    label: "Golden Bell",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "BELL",
    symbolText: "🔔",
    iconText: "🔔",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#eab308",
    color: "#ca8a04",
    type: "fiat",
    image: SLOT_SYMBOL_IMAGES.bell,
    payout: "Mini Jackpot (Min Bet Win)",
    description: "Match 3 Golden Bells to win Mini Progressive Jackpot & Min Bet payout",
  },
  {
    contractNumber: 1,
    id: "diamond",
    label: "Brilliant Diamond",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "DIAMOND",
    symbolText: "💎",
    iconText: "💎",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#2563eb",
    type: "fiat",
    image: SLOT_SYMBOL_IMAGES.diamond,
    payout: "Major Jackpot",
    description: "Match 3 Brilliant Diamonds to win Major Progressive Jackpot",
  },
  {
    contractNumber: 2,
    id: "crown",
    label: "Royal Crown",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "CROWN",
    symbolText: "👑",
    iconText: "👑",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "fiat",
    image: SLOT_SYMBOL_IMAGES.crown,
    payout: "Mega Jackpot",
    description: "Match 3 Royal Crowns to win Grand Mega Progressive Jackpot",
  },
  {
    contractNumber: 3,
    id: "cherries",
    label: "Casino Cherries",
    winningTier: "5 Free Spins",
    winOutcome: "5 Free Spins",
    code: "CHERRY",
    symbolText: "🍒",
    iconText: "🍒",
    multiplier: 15,
    tier: "5 Free Spins",
    tierColor: "#ef4444",
    color: "#dc2626",
    type: "fiat",
    image: SLOT_SYMBOL_IMAGES.cherries,
    payout: "5 Free Spins",
    description: "Match 3 Casino Cherries to trigger 5 Free Spins Bonus Round",
  },
  {
    contractNumber: 4,
    id: "lucky_7",
    label: "Lucky 7",
    winningTier: "10 Super Spins",
    winOutcome: "10 Super Spins",
    code: "SEVEN",
    symbolText: "7️⃣",
    iconText: "7️⃣",
    multiplier: 25,
    tier: "10 Super Spins",
    tierColor: "#dc2626",
    color: "#b91c1c",
    type: "fiat",
    image: SLOT_SYMBOL_IMAGES.lucky_7,
    payout: "10 Super Spins",
    description: "Match 3 Lucky 7s for 10 Super Free Spins Bonus Round",
  },
];

/**
 * CRYPTO Slot 5-Symbol Set (For 3-SlotBET: Contract Mapped 0 to 4)
 */
export const CRYPTO_SET_SYMBOLS = [
  {
    contractNumber: 0,
    id: "pol",
    label: "Polygon POL",
    winningTier: "Mini Jackpot",
    winOutcome: "Mini Bet / Mini Jackpot",
    code: "POL",
    symbolText: "🟣",
    iconText: "🟣",
    multiplier: 10,
    tier: "Mini Jackpot",
    tierColor: "#a855f7",
    color: "#9333ea",
    type: "crypto",
    image: SLOT_SYMBOL_IMAGES.pol,
    payout: "Mini Jackpot (Min Bet Win)",
    description: "Match 3 POL to win Mini Progressive Jackpot & Min Bet payout",
  },
  {
    contractNumber: 1,
    id: "eth",
    label: "Ethereum ETH",
    winningTier: "Major Jackpot",
    winOutcome: "Major Jackpot",
    code: "ETH",
    symbolText: "🔷",
    iconText: "🔷",
    multiplier: 30,
    tier: "Major Jackpot",
    tierColor: "#3b82f6",
    color: "#2563eb",
    type: "crypto",
    image: SLOT_SYMBOL_IMAGES.eth,
    payout: "Major Jackpot",
    description: "Match 3 Ethereum coins to win Major Progressive Jackpot",
  },
  {
    contractNumber: 2,
    id: "btc",
    label: "Bitcoin BTC",
    winningTier: "Mega Jackpot",
    winOutcome: "Mega Jackpot",
    code: "BTC",
    symbolText: "₿",
    iconText: "₿",
    multiplier: 50,
    tier: "Mega Jackpot",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "crypto",
    image: SLOT_SYMBOL_IMAGES.btc,
    payout: "Mega Jackpot",
    description: "Match 3 Bitcoins to win Grand Mega Progressive Jackpot",
  },
  {
    contractNumber: 3,
    id: "sol",
    label: "Solana SOL",
    winningTier: "5 Free Spins",
    winOutcome: "5 Free Spins",
    code: "SOL",
    symbolText: "🟣",
    iconText: "🟣",
    multiplier: 15,
    tier: "5 Free Spins",
    tierColor: "#06b6d4",
    color: "#0891b2",
    type: "crypto",
    image: SLOT_SYMBOL_IMAGES.sol,
    payout: "5 Free Spins",
    description: "Match 3 Solana coins to trigger 5 Free Spins Web3 Bonus Round",
  },
  {
    contractNumber: 4,
    id: "usdt",
    label: "Tether USDT",
    winningTier: "10 Super Spins",
    winOutcome: "10 Super Spins",
    code: "USDT",
    symbolText: "🟢",
    iconText: "🟢",
    multiplier: 25,
    tier: "10 Super Spins",
    tierColor: "#10b981",
    color: "#059669",
    type: "crypto",
    image: SLOT_SYMBOL_IMAGES.usdt,
    payout: "10 Super Spins",
    description: "Match 3 Tether USDT coins for 10 Super Free Spins Bonus Round",
  },
];

/**
 * FIAT Slot 7-Symbol Set (For 5-SlotBET: Contract Mapped 0 to 6)
 * Keeps 5 symbols from 3-slot (#0-#4) + 2 extra symbols (#5 Lucky Clover, #6 Golden Coin)
 */
export const FIAT_7_SET_SYMBOLS = [
  ...FIAT_SET_SYMBOLS,
  {
    contractNumber: 5,
    id: "clover",
    label: "Lucky Clover",
    winningTier: "High Value",
    winOutcome: "High Value Win",
    code: "CLOVER",
    symbolText: "🍀",
    iconText: "🍀",
    multiplier: 20,
    tier: "High Value",
    tierColor: "#10b981",
    color: "#059669",
    type: "fiat",
    image: SLOT_SYMBOL_IMAGES.clover,
    payout: "High value winning payline combinations",
    description: "Match Lucky 4-Leaf Clovers for high-value payouts across paylines!",
  },
  {
    contractNumber: 6,
    id: "coin",
    label: "Golden Coin",
    winningTier: "Top Symbol",
    winOutcome: "Top Symbol Win",
    code: "COIN",
    symbolText: "🪙",
    iconText: "🪙",
    multiplier: 35,
    tier: "Top Symbol",
    tierColor: "#f59e0b",
    color: "#d97706",
    type: "fiat",
    image: SLOT_SYMBOL_IMAGES.coin,
    payout: "Top payout symbol across active paylines",
    description: "AutoBET Golden Coin top payout symbol across all 5 reels!",
  },
];

/**
 * CRYPTO Slot 7-Symbol Set (For 5-SlotBET: Contract Mapped 0 to 6)
 * Keeps 5 symbols from 3-slot (#0-#4) + 2 extra symbols (#5 Binance BNB, #6 AutoBET Gold Token)
 */
export const CRYPTO_7_SET_SYMBOLS = [
  ...CRYPTO_SET_SYMBOLS,
  {
    contractNumber: 5,
    id: "bnb",
    label: "Binance BNB",
    winningTier: "High Value",
    winOutcome: "High Value Win",
    code: "BNB",
    symbolText: "🟡",
    iconText: "🟡",
    multiplier: 20,
    tier: "High Value",
    tierColor: "#eab308",
    color: "#ca8a04",
    type: "crypto",
    image: SLOT_SYMBOL_IMAGES.bnb,
    payout: "High value winning payline combinations",
    description: "Match Binance BNB coins for high-yield Web3 rewards!",
  },
  {
    contractNumber: 6,
    id: "autobet",
    label: "AutoBET Gold Token",
    winningTier: "Top Symbol",
    winOutcome: "Top Symbol Win",
    code: "AUTOBET",
    symbolText: "🪙",
    iconText: "🪙",
    multiplier: 35,
    tier: "Top Symbol",
    tierColor: "#ec4899",
    color: "#db2777",
    type: "crypto",
    image: SLOT_SYMBOL_IMAGES.autobet,
    payout: "Top payout symbol across active paylines",
    description: "AutoBET Gold Token top payout symbol across all 5 reels!",
  },
];

/**
 * Helper to get the symbols mapped based on category and symbol count (5 for 3-slot, 7 for 5-slot)
 */
export const getSymbolsByCategory = (category = "fiat", count = 5) => {
  if (count === 7) {
    return category === "crypto" ? CRYPTO_7_SET_SYMBOLS : FIAT_7_SET_SYMBOLS;
  }
  return category === "crypto" ? CRYPTO_SET_SYMBOLS : FIAT_SET_SYMBOLS;
};
